import { OctTablePagination } from "@oceantech/oceantech-ui";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { TableCustom } from "../../component/table/table-custom/TableCustom";
import {
	DEFAULT_PAGE_INDEX,
	DEFAULT_PAGE_SIZE,
	SELECTION_MODE
} from "../../utils/Constant";
import {
	rowsForPage
} from "../../utils/PageUtils";
import { Props } from "./type";

const TableTemplate = ({
	data,
	columns,
	paging,
	onPagingChange,
	tableOptions,
	selectable,
	tableClassname,
}: Props) => {
	const [page, setPage] = useState(DEFAULT_PAGE_INDEX);
	const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_PAGE_SIZE);

	useEffect(() => {
		if (paging?.page && paging.page !== page) {
			setPage(paging?.page);
		}

		if (paging?.rowsPerPage && paging.rowsPerPage !== rowsPerPage) {
			setRowsPerPage(paging?.rowsPerPage);
		}
	}, [paging?.page, paging?.rowsPerPage]);

	useEffect(() => {
		if (paging?.page !== page || paging?.rowsPerPage !== rowsPerPage) {
			onPagingChange?.(page, rowsPerPage);
		}
	}, [page, rowsPerPage]);

	return (
		<div className="d-flex flex-column">
			<div className="flex-column-fluid">
				<TableCustom
					data={data}
					columns={columns}
					className={clsx("spaces p-0", tableClassname)}
					selectionMode={selectable ? SELECTION_MODE.MULTI : undefined}
					tableOptions={tableOptions}
				/>
			</div>
			{paging && (
				<div className="flex-column-auto">
					<OctTablePagination
						page={page}
						rowsPerPage={rowsPerPage}
						rowsForPage={rowsForPage}
						setPage={setPage}
						setRowsPerPage={setRowsPerPage}
						totalPages={paging.totalPages}
						totalElements={paging.totalElements}
						numberOfElements={paging.numberOfElements}
					/>
				</div>
			)}
		</div>
	);
};

export default TableTemplate;
